module.exports = __webpack_public_path__ + "static/media/x.e1f2ff7e.svg";